import { render, staticRenderFns } from "./AddDB.vue?vue&type=template&id=6a1ba75b&scoped=true&"
import script from "./AddDB.vue?vue&type=script&lang=js&"
export * from "./AddDB.vue?vue&type=script&lang=js&"
import style0 from "./AddDB.vue?vue&type=style&index=0&id=6a1ba75b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1ba75b",
  null
  
)

export default component.exports